const MODE_NORMAL_PAGE = 0x00
const MODE_MODAL_SHOWING = 0x01

export default {
  props: {
    isShowing: {
      type: Boolean,
      required: true
    },
    backgroundEscape: {
      type: Boolean,
      default: true
    }
  },

  beforeRouteLeave() {
    // If we leave the current this.$route we want to make sure that any
    // modals that were open get closed.
    this.pageMode(MODE_NORMAL_PAGE)
  },

  watch: {
    isShowing: function (val) {
      if (val) {
        this.pageMode(MODE_MODAL_SHOWING)
      } else {
        this.pageMode(MODE_NORMAL_PAGE)
      }
    }
  },

  data() {
    // We keep track of this component instances page mode. That doesn't mean
    // that we know whether another modal instance is open. This is used to track
    // and page mode changes being idempotent and prevent doing work that is not
    // necessary or that could conflict with another modal.
    return {
      currentPageMode: MODE_NORMAL_PAGE
    }
  },

  mounted() {
    const modal = this.$refs.modal

    if (!modal) {
      throw new Error('Could not find modal. Make sure you set ref="modal" on the <div> that has class="modal".')
    }

    if (this.backgroundEscape) {
      // Clicking on the background around the outside of the modal window
      this._clickHandler = (event) => {
        if (event.target === modal) {
          this.closeModal()
        }
      }
    }

    // Hitting the escape key
    this._keydownHandler = (event) => {
      if (event.key === 'Escape' && this.isShowing) {
        this.closeModal()
      }
    }

    modal.addEventListener('click', this._clickHandler)
    document.body.addEventListener('keydown', this._keydownHandler)

    if (this.isShowing) {
      this.pageMode(MODE_MODAL_SHOWING)
    }
  },

  beforeDestroy() {
    // If something destroys this modal (which means it's no longer being rendered)
    // we want to return the body to the normal state. Without this the modal will
    // vanish but the background and modal setup will still remain.
    this.pageMode(MODE_NORMAL_PAGE)

    this.$refs.modal.removeEventListener('click', this._clickHandler)
    document.body.removeEventListener('keydown', this._keydownHandler)
  },

  methods: {
    pageMode(mode) {
      // Check what the current page mode is and make the operation a noop
      // to prevent any race conditions with other modals showing/hiding in
      // other views.
      if (this.currentPageMode === mode) {
        return
      }

      const body = document.body
      const modal = this.$refs.modal

      if (!modal) return

      this.currentPageMode = mode

      if (mode === MODE_NORMAL_PAGE) {
        body.style.overflow = 'visible'
        modal.style.visibility = 'hidden'
        modal.style.opacity = 0
        this.displayModal = false
      }

      if (mode === MODE_MODAL_SHOWING) {
        body.style.overflow = 'hidden'
        modal.style.visibility = 'visible'
        modal.style.opacity = 1
        this.displayModal = false
      }
    },

    closeModal() {
      this.$emit('close-modal')
    }
  }
}
